/** @format */
import {AccountDesignsOrdersContext} from 'frontier/account/components/context/AccountDesignsOrdersContext';
import SingleDesignPreview from '../../../../shared/single_design_preview';
import React from 'react';

export const SingleDesignUngrouped = props => {
    const showThumbnails = props.showThumbnails || false;

    return (
        <div className={'d-flex align-items-center justify-content-start w-100'}>
            <SingleDesignPreview showThumbnails={showThumbnails} scrollModalToEvent />
        </div>
    );
};

export const FileColumn = props => {
    const designOrder = props.designOrder;
    const order = props;

    return (
        <AccountDesignsOrdersContext.Provider
            key={designOrder.id}
            value={{
                design: designOrder.design,
                designs_order: designOrder,
                size: order.size,
                order
            }}>
            <SingleDesignUngrouped {...props} />
        </AccountDesignsOrdersContext.Provider>
    );
};
